class DateUtils {
  static shortMonth(date: Date, lng: string) {
    if (!date) {
      return '';
    }
    return this.shortMonthByIndex(date.getMonth(), lng);
  }

  static shortMonthList() {
    return [
      { en: 'Jan', de: 'Jan' },
      { en: 'Feb', de: 'Feb' },
      { en: 'Mar', de: 'Mär' },
      { en: 'Apr', de: 'Apr' },
      { en: 'May', de: 'Mai' },
      { en: 'Jun', de: 'Jun' },
      { en: 'Jul', de: 'Jul' },
      { en: 'Aug', de: 'Aug' },
      { en: 'Sep', de: 'Sep' },
      { en: 'Oct', de: 'Okt' },
      { en: 'Nov', de: 'Nov' },
      { en: 'Dec', de: 'Dez' },
    ];
  }

  static shortMonthByIndex(index: number, lng: string) {
    const list = this.shortMonthList();
    return lng === 'de' ? list[index].de : list[index].en;
  }

  static shortMonthYear(date: Date, lng: string) {
    if (!date) {
      return '';
    }
    return this.shortMonth(date, lng) + ' ' + date.getFullYear().toString().substr(-2);
  }

  static dateMonthYear(date: Date, lng: string) {
    if (!date) {
      return '';
    }
    return (
      date.getDate() +
      '. ' +
      date.toLocaleString(lng, { month: 'long' }) +
      ' ' +
      date.getFullYear().toString()
    );
  }

  static getDaysUntil(target: Date) {
    if (target === null) {
      return null;
    }
    const today = new Date();

    // Normalize times to avoid timezone issues
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);

    const diffMs = target.getTime() - today.getTime();
    const diffDays = Math.round(diffMs / 86400000);

    return diffDays;
  }
}

export default DateUtils;
